<form [formGroup]="dateForm" fxLayout="row" fxLayoutAlign="space-between center" fxFlex="100%">
  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" fxFlex="45%" class="from-block">
    <mat-form-field class="datepicker" color="accent">
      <input
        matInput
        formControlName="date"
        [matDatepicker]="datePicker"
        (focus)="datePicker.open()"
      />
      <mat-datepicker-toggle [disableRipple]="true" matSuffix [for]="datePicker">
        <mat-icon matDatepickerToggleIcon>arrow_drop_down</mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #datePicker></mat-datepicker>
      <mat-hint *ngIf="dateForm.dirty" (click)="reset()">{{ 'FILTER_ENGINE.CLEAR' | translate }}</mat-hint>
    </mat-form-field>

    <div [ngClass]="{ 'timepicker-visible': date.value }" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px" class="timepicker-hidden">
      <mat-form-field class="timepicker-select" color="accent">
        <mat-select formControlName="hours" [placeholder]="'FILTER_ENGINE.DATE_PLACEHOLDER_HOURS' | translate">
          <mat-option *ngFor="let hour of allHours" [value]="hour">{{ hour | number: '2.0-0' }}</mat-option>
        </mat-select>
      </mat-form-field>
      <span>:</span>
      <mat-form-field class="timepicker-select" color="accent">
        <mat-select formControlName="minutes" [placeholder]="'FILTER_ENGINE.DATE_PLACEHOLDER_MINUTES' | translate">
          <mat-option *ngFor="let minute of allMinutes" [value]="minute">{{ minute | number: '2.0-0' }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
</form>
